export { default } from './pharmaprix-owners-header.component';
